<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<div class="header-container">
			<div class="search-swiper-container">				
				<Swiper :list="release_sliders"/>
			</div>
		</div>
		
		<div class="content">
			<div class="content-tabs">
				<button
					type="button"
					class="content-tabs__item"
					:class="{ 'content-tabs__item--active': activeTab === 'news' }"
					@click="switchTab('news')"
				>资讯</button>
				<button
					type="button"
					class="content-tabs__item"
					:class="{ 'content-tabs__item--active': activeTab === 'visual' }"
					@click="switchTab('visual')"
				>视觉</button>
			</div>

			<div class="news-container" v-show="activeTab === 'news'">
				<section id="news-wrapper" class="news-wrapper">
					<div class="news-right">
						<Loading :is-loading="isPicLoading"></Loading>
						<div class="news-item" v-for="item in picList" :key="item.id" @click="toDetail(item.id)">
							<div class="news-item-outer">
								<div class="img-outer">
									<img :src="item.thumb" oncontextmenu="return false" :alt="item.title"/>
								</div>
								<div class="news-title">
									<span v-html="item.title"></span>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div class="loadmore">
					<Loading :is-loading="isPicLoading"></Loading>
					<span class="more" @click="loadMore(pictype)" v-if="!picNomore && !isPicLoading">{{$t('loadmore')}}</span>
					<span class="end" v-if="picNomore && !isPicLoading && picList.length">- {{$t('theEnd')}} -</span>
				</div>
			</div>

			<div class="news-container" v-show="activeTab === 'visual'">
				<section id="news-wrapper" class="news-wrapper">
					<div class="enclosure">
						<Loading :is-loading="isVideoLoading"></Loading>
						<section class="section masonry">
							<div class="masonry-column" v-for="(column, colIndex) in videoColumns" :key="colIndex">
								<div class="_1Aw4E" v-for="item in column" :key="item.id">
									<div @click="toVideoDetail(item.id)" style="width:100%;">
										<video v-if="isMobile"
										    :poster="item.thumb"
										    preload="none"
										    muted
										    :alt="item.title"
										    :style="getVideoAspectStyle(item)"
										    controlslist="nodownload"
										    oncontextmenu="return false">
											<track kind="captions" />
											<source :src="item.video" type="video/mp4">
										</video>
										<video v-if="!isMobile"
										    controls
										    :poster="item.thumb"
										    preload="none"
										    muted
										    :alt="item.title"
										    :style="getVideoAspectStyle(item)"
										    controlslist="nodownload"
										    oncontextmenu="return false"
										    :src="item.video">
											<track kind="captions" />
										</video>
									</div>
									<div class="video_name">
										<span>{{ item.title }}</span>
									</div>
								</div>
							</div>
						</section>
					</div>
				</section>
				<div class="loadmore">
					<Loading :is-loading="isVideoLoading"></Loading>
					<span class="more" @click="loadMore(videotype)" v-if="!videoNomore && !isVideoLoading">{{$t('loadmore')}}</span>
					<span class="end" v-if="videoNomore && !isVideoLoading && videoList.length">- {{$t('theEnd')}} -</span>
				</div>
			</div>

		</div>
		<Footer/>
	</div>
</template>

<script>
	import publish from './publish_controller';
	export default publish;
</script>

<style src="@/assets/css/publish.css" scoped></style>
<style scoped>
.content-tabs {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 16px 10px 8px;
	max-width: 1403px;
	margin: 0 auto;
}
.content-tabs__item {
	height: 36px;
	padding: 0 18px;
	border: 0;
	border-radius: 5px;
	background: #fff;
	color: #000;
	font-size: 16px;
	cursor: pointer;
	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
}
.content-tabs__item--active {
	background: rgba(223, 58, 8, 1);
	color: #fff;
}
</style>
